import CountUp from "react-countup"
import { styled, VStack } from "styled-system/jsx"

const StatTitle = styled("h3", {
  base: {
    textAlign: "center",
    fontFamily: "heading",
    fontSize: "60px",
    fontWeight: "700",
    lineHeight: "150%",
    letterSpacing: "-1.32px",
  },
})

const StatText = styled("p", {
  base: {
    textAlign: "center",
    fontFamily: "heading",
    fontSize: "23px",
    fontWeight: "500",
    lineHeight: "150%",

    lgDown: {
      fontSize: "18px",
      letterSpacing: "-0.198px",
    },
  },
})

function Stat({ number, position, unit, text }) {
  return (
    <VStack>
      <StatTitle>
        <CountUp
          end={number}
          prefix={position === "left" ? unit : ""}
          suffix={position === "right" ? unit : ""}
          duration={2}
          enableScrollSpy
          scrollSpyOnce
        />
      </StatTitle>
      <StatText>{text}</StatText>
    </VStack>
  )
}

export default Stat
